var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcReadless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1414_3826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0698 1.35107C6.38037 1.35107 0.960449 6.771 0.960449 13.4604C0.960449 20.1499 6.38037 25.5698 13.0698 25.5698C19.7593 25.5698 25.1792 20.1499 25.1792 13.4604C25.1792 6.771 19.7593 1.35107 13.0698 1.35107ZM6.62451 15.4136C6.30225 15.4136 6.03857 15.1499 6.03857 14.8276V12.0933C6.03857 11.771 6.30225 11.5073 6.62451 11.5073H19.5151C19.8374 11.5073 20.1011 11.771 20.1011 12.0933V14.8276C20.1011 15.1499 19.8374 15.4136 19.5151 15.4136H6.62451Z",
    fill: "#3E8181"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1414_3826"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.569824 0.960449)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReadless);
export default __webpack_public_path__ + "static/media/ic_readless.c673bd891e2bf81d7fd37f575655e325.svg";
export { ForwardRef as ReactComponent };